import $ from 'jquery';

export const langSwitch = () => {
    const $languageSwitcher = $('#options-menu');
    const $languageOptions = $('#language-options');

    $languageSwitcher.on('click', () => {
        $languageOptions.toggleClass('hidden');
    });
}